import { render } from "./PageAccueil.vue?vue&type=template&id=3146ef14&scoped=true"
import script from "./PageAccueil.vue?vue&type=script&lang=js"
export * from "./PageAccueil.vue?vue&type=script&lang=js"

import "./PageAccueil.vue?vue&type=style&index=0&id=3146ef14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3146ef14"]])

export default __exports__